import {
  SessionFeedbackIssue,
  SessionFeedbackIssueDetails,
  studentSessionFeedbackIssues,
} from '@airreading/common/data';

export const LearningIssues: SessionFeedbackIssue[] = [SessionFeedbackIssue.Too_easy, SessionFeedbackIssue.Too_hard];
export const TechnicalIssues: SessionFeedbackIssue[] = [
  SessionFeedbackIssue.Connection_issues,
  SessionFeedbackIssue.Audio_issues,
  SessionFeedbackIssue.Video_issues,
  SessionFeedbackIssue.Other_tech_issues,
];
export const BehaviorIssues: SessionFeedbackIssue[] = [
  SessionFeedbackIssue.Constantly_late,
  SessionFeedbackIssue.Extremely_noisy,
  SessionFeedbackIssue.Strong_behavior_issues,
];

export const StudentIssues: SessionFeedbackIssue[] = [...studentSessionFeedbackIssues];

export const MajorConcernIssues: SessionFeedbackIssue[] = [
  SessionFeedbackIssue.disruptive_or_disrespectful,
  SessionFeedbackIssue.Extremely_noisy,
  SessionFeedbackIssue.extreme_concerns,
  SessionFeedbackIssue.other,
];

interface SessionFeedbackIssueGroup {
  learningIssues: SessionFeedbackIssue[];
  technicalIssues: SessionFeedbackIssue[];
  behaviorIssues: SessionFeedbackIssue[];
}

export function partitionSessionFeedbackIssues(items: SessionFeedbackIssue[]): SessionFeedbackIssueGroup {
  return {
    learningIssues: items.filter((item) => LearningIssues.includes(item)),
    technicalIssues: items.filter((item) => TechnicalIssues.includes(item)),
    behaviorIssues: items.filter((item) => BehaviorIssues.includes(item)),
  };
}

export function getSessionFeedbackEvent(feedback: {
  studentAttended: boolean | null;
  issues: SessionFeedbackIssue[];
}): string | null {
  if (!feedback.studentAttended) {
    return 'Absent';
  }

  if (feedback.issues.length > 0) {
    return feedback.issues.map((issue) => SessionFeedbackIssueDetails[issue].label).join(', ');
  }

  return null;
}

export function resolveIssuesForSave({
  studentAttended,
  feedbackIssues,
  majorConcerns,
  otherTechIssues,
}: {
  studentAttended: boolean | null | undefined;
  feedbackIssues: SessionFeedbackIssue[];
  majorConcerns: string | null | undefined;
  otherTechIssues: string | null | undefined;
}): {
  issues: SessionFeedbackIssue[];
  majorConcerns: string | null | undefined;
  otherTechIssues: string | null | undefined;
} {
  if (studentAttended === false) {
    return { issues: [], majorConcerns: null, otherTechIssues: null };
  }

  const hasMajorConcerns = feedbackIssues.includes(SessionFeedbackIssue.Strong_behavior_issues);
  const hasTechIssue = feedbackIssues.includes(SessionFeedbackIssue.tech_issue);

  const issues = feedbackIssues.filter((issue) => {
    // if Strong_behavior_issues is not selected, filter out the major concern issues
    if (!hasMajorConcerns && MajorConcernIssues.includes(issue)) {
      return false;
    }

    // if tech_issue is not selected, filter out the technical issues
    if (!hasTechIssue && TechnicalIssues.includes(issue)) {
      return false;
    }

    return true;
  });

  return {
    issues,
    majorConcerns: hasMajorConcerns ? majorConcerns : null,
    otherTechIssues: hasTechIssue ? otherTechIssues : null,
  };
}
